module.exports = __webpack_public_path__ + "static/media/filehistory.abdf2ad4.svg";